import React from 'react'
import MovieCard from '../Components/MovieCard';
import SubBanner from '../Components/SubBanner';
import FuzzyText from '../Components/Bits/FuzzyText';

const SeeLater = ({ watchList, setWatchList }) => {
  return (
    <>
      <SubBanner title={'Phim xem sau'} pathName={'SeeLater'} />
      <section className='results-sec'>
        <div className='container'>
          <div className='section-title'>
            <h5 className='sub-title'>RẠP BAGALAXY</h5>
            <h2 className='title'>Phim xem sau</h2>
          </div>
          <div className='row movies-grid text-center'>
            {
              watchList.length
                ?
                watchList.map(movie => (
                  <MovieCard movie={movie} key={movie.imdbID} setWatchList={setWatchList} watchList={watchList} />
                ))
                :
                <FuzzyText
                  baseIntensity={0.2}
                >
                  No movies found
                </FuzzyText>
            }
          </div>
        </div>
      </section>
    </>
  )
}

export default SeeLater;